import React, { useEffect, useState } from 'react'

// react router
import { useHistory } from "react-router-dom";

// styles
import Container from '../../styles/Container'
import OrderSuccessStyles from '../../styles/OrderSuccessStyles'

// icons
import { BsCheck2Circle } from "react-icons/bs";
import { BiCartAlt, BiHomeAlt } from "react-icons/bi";

export default function OrderSucess(props) {
    // props
    const { location } = props

    // states
    const [orderId, setOrderId] = useState("")

    useEffect(() => {
        if (location?.state?.orderId) {
            setOrderId(location.state.orderId)
        }
    }, [location])

    return (
        <OrderSuccessStyles>
            <Container className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 order-success-main d-flex align-items-center justify-content-center">
                        <div className="inner text-center">
                            <BsCheck2Circle fontSize="100" color="#30dc30" />
                            <p className="text-uppercase st-fw-600 my-3" style={{ maxWidth: 500 }}>
                                Congratulations! Your order with order id <span className="st-fw-800">#{orderId}</span> has been placed successfully
                            </p>
                            <div className="d-flex justify-content-center links">
                                <a href="/home" className="text-decoration-none st-fw-600 d-flex align-items-center justify-content-center mx-2">
                                    <span className="icon st-line-height-0"><BiHomeAlt fontSize="15" /></span>
                                    <span className="ms-1" style={{ position: 'relative', top: 1 }}>Home</span>
                                </a>

                                {/* <a href="/home" className="text-decoration-none st-fw-600 d-flex align-items-center justify-content-center mx-2">
                                    <span className="icon st-line-height-0"><BiCartAlt fontSize="15" /></span>
                                    <span className="ms-1" style={{ position: 'relative', top: 1 }}>Your Orders</span>
                                </a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </OrderSuccessStyles>
    )
}
